// extracted by mini-css-extract-plugin
export default {"textload":"Skeleton__textload--z4lGZ","shine":"Skeleton__shine--pn1sd","skeletonimg":"Skeleton__skeletonimg--jGvTp Skeleton__textload--z4lGZ"};